import {visitedPageConstants} from "_constants";

const INITIAL_STATE = {
    saveVisitedPage: {},
    getVisitedPageLoading: false,
    getVisitedPageError: '',

    getVisitedPage: {},
    saveVisitedPageLoading: false,
    saveVisitedPageError: '',
};

export function visitedPageReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case visitedPageConstants.GET_VISITED_PAGE_REQUEST:
            return {...state, getVisitedPageLoading: true};
        case visitedPageConstants.GET_VISITED_PAGE_SUCCESS:
            return {...state, getVisitedPage: action.payload, getVisitedPageLoading: false};
        case visitedPageConstants.GET_VISITED_PAGE_FAILURE:
            return {...state, getVisitedPageError: action.error, getVisitedPageLoading: false};

        case visitedPageConstants.SAVE_VISITED_PAGE_REQUEST:
            return {...state, saveVisitedPageLoading: true};
        case visitedPageConstants.SAVE_VISITED_PAGE_SUCCESS:
            return {...state, saveVisitedPage: action.payload, saveVisitedPageLoading: false};
        case visitedPageConstants.SAVE_VISITED_PAGE_FAILURE:
            return {...state, saveVisitedPageError: action.error, saveVisitedPageLoading: false};

        default:
            return state
    }
}